import CustomGrid from '@components/shared/CustomGrid';
import FAQ from '@components/shared/FAQ';
import { Heading } from '@components/transferTracking/Heading';
import { OrderSearchBar } from '@components/transferTracking/transferDetails/OrderSearchBar';
import { ToolsNavigation } from '@components/transferTracking/ToolsNavigation';
import { Divider, Grid, useTheme } from '@mui/material';

export const withContentLayout = (WrappedFormComponent) => (props) => {
	const theme = useTheme();

	return (
		<>
			<CustomGrid>
				<ToolsNavigation />
				<Heading />
				<OrderSearchBar />
			</CustomGrid>

			<Grid container>
				<Grid item xs={12}>
					<WrappedFormComponent />
				</Grid>
			</Grid>

			<Grid
				container
				sx={{
					background: theme.palette.background.paper,
					width: '100%',
					justifyContent: 'center'
				}}>
				<Grid item sx={{ width: { xs: '90%', sm: '90%', lg: '70%' } }}>
					<FAQ />
				</Grid>
				<Grid item sx={{ width: '100%' }}>
					<Divider sx={{ borderColor: theme.surfaces.level2 }} />
				</Grid>
			</Grid>
		</>
	);
};
